module.exports = __webpack_public_path__ + "static/media/sort-arrow-up.059067b1.svg";